import { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';

import { ActionType, StateToken } from '@ngxs/store';

import {
  DestinationAdGroup,
  DestinationGroup,
  DestinationInstance,
  DestinationSource,
} from '@app/criterion-addition/shared/models/destination.models';
import { AdPlatform } from '@app/core/models/common.models';
import { KeyOf } from '@app/core/utilities/typescript.utilities';
import { AdGroup } from '@app/core/models/ad-group.models';

export interface DestinationMatchTypeStateModel {
  source?: DestinationSource;
  destinations?: DestinationGroup[];
  adGroups?: DestinationAdGroup[];
  selectedAdGroups?: DestinationAdGroup[];
}

export interface DestinationAdGroupSortProperty {
  label: string;
  value: Partial<Record<KeyOf<AdGroup>, number>>;
  sponsoredProductsOnly?: boolean;
}

export const DESTINATION_MATCH_TYPE_STATE = new StateToken<DestinationMatchTypeStateModel>('destinationMatchType');

export const DESTINATION_AD_GROUP_TYPE = new InjectionToken<ActionType>('destinationAdGroupType');

export const DESTINATION_AD_GROUP_SERVICE = new InjectionToken<DestinationAdGroupService>('destinationAdGroupService');

export const DESTINATION_AD_GROUP_SORT_PROPERTIES = new InjectionToken<DestinationAdGroupSortProperty[]>(
  'destinationAdGroupSortProperties',
);

export interface DestinationAdGroupService<T extends DestinationAdGroup = DestinationAdGroup> {
  readonly isSponsoredProductsAuto$?: Observable<boolean>;
  readonly platform$: Observable<AdPlatform>;
  readonly adGroups$: Observable<T[]>;
  readonly selected$?: Observable<DestinationInstance[]>;
  readonly selectedAdGroups$: Observable<T[]>;
  readonly tourStepDestination$?: Observable<string>;
  readonly tourStepDestinationOrder?: number;
  readonly tourMatchType$?: Observable<string>;
  readonly tourStepMatchTypeOrder?: number;

  deselectAdGroup(adGroup: T): void;
  selectAdGroup(adGroup: T): void;
}
